module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self"
  }, _vm._l((_vm.courses), function(course) {
    return _c('div', {
      staticClass: "course"
    }, [_c('div', {
      staticClass: "image-area"
    }, [(course.imageUrl) ? _c('img', {
      attrs: {
        "src": _vm.getImg(course)
      }
    }) : _vm._e()]), _c('p', {
      staticClass: "fields-area"
    }, [_c('router-link', {
      staticClass: "name",
      attrs: {
        "to": '/progress/course/' + course.id
      }
    }, [_vm._v(_vm._s(course.name))]), _c('br')], 1), _c('p', {
      staticClass: "summary",
      domProps: {
        "innerHTML": _vm._s(course.summary)
      }
    }), _c('br'), (course.details) ? _c('div', [(!course.showDetails) ? _c('span', [_c('a', {
      staticClass: "toggle-details-link",
      on: {
        "click": function($event) {
          course.showDetails = true
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-triangle-right"
    }), _vm._v("\nafficher les détails")])]) : _c('span', [_c('a', {
      staticClass: "toggle-details-link",
      on: {
        "click": function($event) {
          course.showDetails = false
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-triangle-bottom"
    }), _vm._v("\nmasquer les détails")]), _c('br'), _c('span', {
      staticClass: "details",
      domProps: {
        "innerHTML": _vm._s(course.details)
      }
    })])]) : _vm._e(), _c('p')])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77d89edc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/learn/CourseList.vue
// module id = 598
// module chunks = 2